import { Home, ChefHat, Camera, MoreHorizontal } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface NavItem {
  key: string;
  /** English fallback label (also used when i18nKey is null) */
  label: string;
  /** react-i18next key for translated label, or null for always-static labels */
  i18nKey: string | null;
  icon: LucideIcon;
  path: string;
  /** Active accent color — bronze for Home/Recipes/More, sage for GlucoPhoto */
  accentColor: string;
}

export const NAV_ITEMS: NavItem[] = [
  { key: 'home',       label: 'Home',       i18nKey: 'nav.home',    icon: Home,           path: '/home',       accentColor: 'hsl(var(--accent))' },
  { key: 'recipes',    label: 'Recipes',    i18nKey: 'nav.recipes', icon: ChefHat,        path: '/recipes',    accentColor: 'hsl(var(--accent))' },
  { key: 'glucophoto', label: 'GlucoPhoto', i18nKey: null,          icon: Camera,         path: '/glucophoto', accentColor: 'hsl(var(--sem-verde))' },
  { key: 'more',       label: 'More',       i18nKey: 'nav.more',    icon: MoreHorizontal, path: '/more',       accentColor: 'hsl(var(--accent))' },
];
